


































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { newCertificateOfInsurance, editCertificateOfInsurance } from '@/modules/CertificateOfInsurance/gql/certificate.gql'
import COIFormInfo from '@/modules/CertificateOfInsurance/components/forms/COIFormInfo.vue'
import { ICOIInput } from '@/modules/CertificateOfInsurance/interfaces/coi-form'
import { CertificateOfInsurance } from '@/modules/CertificateOfInsurance/interfaces/certificate-of-insurance'
import { Account } from '@/modules/Account/interfaces/account'

@Component({
  components: {
    COIFormInfo,
    AppDialog,
    AppSteps

  }
})
export default class CertificateOfInsuranceForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => CertificateOfInsurance }) readonly coi!: CertificateOfInsurance
  @Prop({ type: Object as () => Account }) readonly account!: Account

  showDialog = false
  loading = false

  recordTypeIndex = 0
  stepIndex = 0

  steps = [
    ['COI Info', 770, 435]
  ]

  infoInput: ICOIInput = {
    generalLiabilityPolicy: {},
    automobilePolicy: {},
    umbrellaExcessPolicy: {},
    workersCompensationPolicy: {},
    otherPolicy: {},
    revisionNumber: ''
  }

  get ifEdit () {
    return !!this.coi
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.coi
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.coi ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex === 3
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.coi) {
      const {
        policies: {
          generalLiabilityPolicy,
          automobilePolicy,
          umbrellaExcessLiabilityPolicy,
          workersCompensationPolicy,
          otherPolicy
        },
        revisionNumber
      } = this.coi
      this.infoInput = {
        revisionNumber,
        generalLiabilityPolicy: {
          id: generalLiabilityPolicy
            ? +generalLiabilityPolicy.id
            : undefined,
          name: generalLiabilityPolicy ? generalLiabilityPolicy.policyName : ''
        },
        automobilePolicy: {
          id: automobilePolicy
            ? +automobilePolicy.id
            : undefined,
          name: automobilePolicy ? automobilePolicy.policyName : ''
        },
        umbrellaExcessPolicy: {
          id: umbrellaExcessLiabilityPolicy
            ? +umbrellaExcessLiabilityPolicy.id
            : undefined,
          name: umbrellaExcessLiabilityPolicy ? umbrellaExcessLiabilityPolicy.policyName : ''
        },
        workersCompensationPolicy: {
          id: workersCompensationPolicy
            ? +workersCompensationPolicy.id
            : undefined,
          name: workersCompensationPolicy ? workersCompensationPolicy.policyName : ''
        },
        otherPolicy: {
          id: otherPolicy
            ? +otherPolicy.id
            : undefined,
          name: otherPolicy ? otherPolicy.policyName : ''
        }
      }
    } else {
      this.clearForm()
    }
  }

  handleStepClick (index: number) {
    if (!this.coi) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.coi) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    }
  }

  async handleCreate () {
    const {
      revisionNumber,
      generalLiabilityPolicy: {
        id: generalLiabilityPolicyId
      },
      automobilePolicy: {
        id: automobilePolicyId
      },
      umbrellaExcessPolicy: {
        id: umbrellaExcessLiabilityPolicyId
      },
      workersCompensationPolicy: {
        id: workersCompensationPolicyId
      },
      otherPolicy: {
        id: otherPolicyId
      }
    } = this.infoInput

    try {
      const res = await this.$apollo.mutate({
        mutation: newCertificateOfInsurance,
        variables: {
          input: {
            accountId: +this.account.id,
            revisionNumber,
            generalLiabilityPolicyId: generalLiabilityPolicyId ? +generalLiabilityPolicyId : null,
            automobilePolicyId: automobilePolicyId ? +automobilePolicyId : null,
            umbrellaExcessLiabilityPolicyId: umbrellaExcessLiabilityPolicyId ? +umbrellaExcessLiabilityPolicyId : null,
            workersCompensationPolicyId: workersCompensationPolicyId ? +workersCompensationPolicyId : null,
            otherPolicyId: otherPolicyId ? +otherPolicyId : null
          }
        }
      })
      this.onSuccess('Create the new certificate successfully')
      this.clearForm()
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      revisionNumber,
      generalLiabilityPolicy: {
        id: generalLiabilityPolicyId
      },
      automobilePolicy: {
        id: automobilePolicyId
      },
      umbrellaExcessPolicy: {
        id: umbrellaExcessLiabilityPolicyId
      },
      workersCompensationPolicy: {
        id: workersCompensationPolicyId
      },
      otherPolicy: {
        id: otherPolicyId
      }
    } = this.infoInput
    const accountId = this.account
      ? +this.account.id
      : this.coi.account
        ? +this.coi.account.id
        : -1
    try {
      const res = await this.$apollo.mutate({
        mutation: editCertificateOfInsurance,
        variables: {
          coiId: +this.coi.id,
          input: {
            accountId,
            revisionNumber,
            generalLiabilityPolicyId: generalLiabilityPolicyId ? Number(generalLiabilityPolicyId) : null,
            automobilePolicyId: automobilePolicyId ? +automobilePolicyId : null,
            umbrellaExcessLiabilityPolicyId: umbrellaExcessLiabilityPolicyId ? +umbrellaExcessLiabilityPolicyId : null,
            workersCompensationPolicyId: workersCompensationPolicyId ? +workersCompensationPolicyId : null,
            otherPolicyId: otherPolicyId ? +otherPolicyId : null
          }
        }
      })
      this.onSuccess('Update case successfully')
      this.clearForm()
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loading = false
    this.infoInput = {
      generalLiabilityPolicy: {},
      automobilePolicy: {},
      umbrellaExcessPolicy: {},
      workersCompensationPolicy: {},
      otherPolicy: {},
      revisionNumber: ''
    }
  }

  @Emit('hide')
  handleHide () {
    this.$emit('input', false)
  }

  @Emit('cancel')
  handleCancel () {
    this.handleHide()
    this.clearForm()
  }

  @Emit('success')
  @Emit('hide')
  onSuccess (msg = '') {
    this.handleHide()
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
